// extracted by mini-css-extract-plugin
export var equalColumn = "_iz-0";